function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M1.3,3h21.3C23.4,3,24,3.7,24,4.5v15.1c0,0.9-0.5,1.5-1.3,1.5H1.3C0.6,21,0,20.5,0,19.5V4.5C0,3.7,0.6,3,1.3,3z                                        M22.8,5l-6.6,6.7l6.6,7.5V5z M15.4,12.6l-3.1,3.2c-0.2,0.2-0.6,0.2-0.8,0l-2.9-3l-6.1,7h19.2L15.4,12.6z M7.7,11.9L1.2,5.2v14.2                                        L7.7,11.9z M2,4.3l9.9,10.1l10-10.1H2z"
});

function SvgEmail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgICA8cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNMS4zLDNoMjEuM0MyMy40LDMsMjQsMy43LDI0LDQuNXYxNS4xYzAsMC45LTAuNSwxLjUtMS4zLDEuNUgxLjNDMC42LDIxLDAsMjAuNSwwLDE5LjVWNC41QzAsMy43LDAuNiwzLDEuMywzegogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBNMjIuOCw1bC02LjYsNi43bDYuNiw3LjVWNXogTTE1LjQsMTIuNmwtMy4xLDMuMmMtMC4yLDAuMi0wLjYsMC4yLTAuOCwwbC0yLjktM2wtNi4xLDdoMTkuMkwxNS40LDEyLjZ6IE03LjcsMTEuOUwxLjIsNS4ydjE0LjIKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgTDcuNywxMS45eiBNMiw0LjNsOS45LDEwLjFsMTAtMTAuMUgyeiI+PC9wYXRoPgo8L3N2Zz4=";
export { SvgEmail as ReactComponent };